<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm10 md6 lg5 xl4>
<!--        <v-card tile>-->
<!--          <v-toolbar dark dense flat color="primary">-->
<!--            <v-toolbar-title>云南省工业和信息化厅项目管理系统-登录</v-toolbar-title>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-tooltip right>-->
<!--              <v-btn-->
<!--                icon-->
<!--                large-->
<!--                href="#"-->
<!--                target="_blank"-->
<!--                slot="activator"-->
<!--              >-->
<!--                <v-icon large>help_outline</v-icon>-->
<!--              </v-btn>-->
<!--              <span>需要帮助？</span>-->
<!--            </v-tooltip>-->
<!--          </v-toolbar>-->
<!--          <v-progress-linear class="my-0" :indeterminate="true" v-if="loginLoading" :active="loginLoading" height="2"-->
<!--                             color="orange"/>-->

<!--          <v-alert-->
<!--            type="error"-->
<!--            :value="showMessage"-->
<!--            style="margin: 0;border-color: transparent !important;"-->
<!--          >-->
<!--            {{ message }}-->
<!--          </v-alert>-->
<!--          <v-stepper v-model="step" class="elevation-0">-->
<!--            <v-stepper-items>-->
<!--              &lt;!&ndash; 步骤1: 基础登录信息 &ndash;&gt;-->
<!--              <v-stepper-content step="1" class="pa-0">-->
<!--                <v-card-text>-->
<!--                  <v-form>-->
<!--                    <v-text-field-->
<!--                      :disabled="loginLoading"-->
<!--                      prepend-icon="person"-->
<!--                      v-model="userDeptRole.username"-->
<!--                      name="username"-->
<!--                      label="统一社会信用代码/电子邮箱/用户名"-->
<!--                      :rules="rules.username"-->
<!--                      id="username"-->
<!--                      type="text"/>-->
<!--                    <v-text-field-->
<!--                      :disabled="loginLoading"-->
<!--                      prepend-icon="lock"-->
<!--                      v-model="userDeptRole.password"-->
<!--                      name="password"-->
<!--                      label="密码"-->
<!--                      id="password"-->
<!--                      type="password"-->
<!--                      @keyup.enter="onLogin"-->
<!--                    />-->

<!--                    <v-text-field-->
<!--                      :disabled="loginLoading"-->
<!--                      v-model="captchaText"-->
<!--                      label="验证码"-->
<!--                      prepend-icon="vpn_key"-->
<!--                      @keyup.enter="onLogin">-->
<!--                      <template slot="append">-->
<!--                        <img :src="captchaUrl"-->
<!--                             @click="getCaptcha"-->
<!--                             style="height: 40px" alt="验证码"/>-->
<!--                      </template>-->
<!--                    </v-text-field>-->
<!--                  </v-form>-->
<!--                </v-card-text>-->
<!--                <v-card-actions>-->
<!--&lt;!&ndash;                  <v-btn color="primary" flat @click="$router.push('/register')" :disabled="loginLoading">注册新用户&ndash;&gt;-->
<!--&lt;!&ndash;                  </v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-btn color="primary" flat to="/forget">找回密码？</v-btn>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-spacer></v-spacer>&ndash;&gt;-->
<!--&lt;!&ndash;                  <v-btn color="primary" @click.native.stop="onLogin" :disabled="loginLoading">&ndash;&gt;-->
<!--&lt;!&ndash;                    {{ loginLoading ? '正在登录' : '登录' }}&ndash;&gt;-->
<!--&lt;!&ndash;                  </v-btn>&ndash;&gt;-->
<!--                </v-card-actions>-->
<!--              </v-stepper-content>-->

<!--              &lt;!&ndash; 步骤2: 邮箱验证码 (仅admin用户需要) &ndash;&gt;-->
<!--              <v-stepper-content step="2" class="pa-0">-->
<!--                <v-card-text>-->
<!--                  <v-form>-->
<!--                    <v-subheader>管理员安全验证</v-subheader>-->
<!--                    <v-alert type="info" :value="true" class="mb-3">-->
<!--                      检测到管理员登录，已向您的邮箱发送验证码-->
<!--                    </v-alert>-->

<!--                    <v-text-field-->
<!--                      :disabled="loginLoading"-->
<!--                      prepend-icon="email"-->
<!--                      v-model="emailCode"-->
<!--                      name="emailCode"-->
<!--                      label="邮箱验证码"-->
<!--                      type="text"-->
<!--                      @keyup.enter="verifyEmailCode"-->
<!--                    />-->

<!--                    <div class="email-code-actions">-->
<!--                      <v-btn-->
<!--                        color="primary"-->
<!--                        flat-->
<!--                        small-->
<!--                        @click="sendEmailCode"-->
<!--                        :disabled="emailCodeCooldown > 0"-->
<!--                      >-->
<!--                        {{ emailCodeCooldown > 0 ? `${emailCodeCooldown}秒后重新发送` : '重新发送验证码' }}-->
<!--                      </v-btn>-->
<!--                    </div>-->
<!--                  </v-form>-->
<!--                </v-card-text>-->
<!--                <v-card-actions>-->
<!--                  <v-btn color="primary" flat @click="step = 1" :disabled="loginLoading">上一步</v-btn>-->
<!--                  <v-spacer></v-spacer>-->
<!--                  <v-btn color="primary" @click="verifyEmailCode" :disabled="loginLoading">-->
<!--                    {{ loginLoading ? '验证中' : '验证' }}-->
<!--                  </v-btn>-->
<!--                </v-card-actions>-->
<!--              </v-stepper-content>-->

<!--              &lt;!&ndash; 步骤3: 选择部门和角色 &ndash;&gt;-->
<!--              <v-stepper-content step="3" class="pa-0">-->
<!--                <v-card-text>-->
<!--                  <v-form>-->
<!--                    <v-subheader>请选择部门和角色</v-subheader>-->
<!--                    <v-radio-group-->
<!--                      v-model="userDeptRoleSel"-->
<!--                      @change="onDeptRoleChange"-->
<!--                      class="pt-0 pl-3"-->
<!--                    >-->
<!--                      <v-radio-->
<!--                        v-for="udr in userDeptRoleItems"-->
<!--                        :key="`${udr.deptId}-${udr.roleId}`"-->
<!--                        :label="`${udr.deptName}[${udr.roleName}]`"-->
<!--                        :value="udr"-->
<!--                      />-->
<!--                    </v-radio-group>-->
<!--                  </v-form>-->
<!--                </v-card-text>-->
<!--                <v-card-actions>-->
<!--                  <v-btn color="primary" flat @click="step = isAdmin ? 2 : 1" :disabled="loginLoading">上一步</v-btn>-->
<!--                  <v-spacer></v-spacer>-->
<!--                  <v-btn color="primary" @click="doLogin" :disabled="loginLoading">-->
<!--                    {{ loginLoading ? '正在登录' : '确定' }}-->
<!--                  </v-btn>-->
<!--                </v-card-actions>-->
<!--              </v-stepper-content>-->
<!--            </v-stepper-items>-->
<!--          </v-stepper>-->
<!--        </v-card>-->
        <v-card class="mt-3">
          <v-card-text class="py-2 px-4">
            <p style="color: red">
              通知：<br/>
              云南省工业和信息化厅项目管理系统已迁移，本地址不再提供服务，请通过网址 <a href="https://report.ynaii.net/">https://report.ynaii.net/</a>进行访问,请相关部门和相关企业收藏该网址，确保工作顺利开展。<br/>
            </p>
          </v-card-text>
<!--          <v-card-text class="py-2 px-4">-->
<!--            <p>-->
<!--              技术支持 ：<a href="http://www.ynmaker.com">云南唯恒基业科技有限公司</a>-->
<!--              <br/>-->
<!--              咨询电话 ：15223829759、15391343287、13708894643-->
<!--              <br/>-->
<!--              服务时间 ：工作日 上午8:00-12:00，下午14:00-17:00-->
<!--            </p>-->
<!--          </v-card-text>-->
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
const loginURI = '/api/login';

export default {
  data: () => ({
    loginLoading: false,
    afterLogin: null,

    captchaId: '',
    captchaUrl: '',
    errorMsg: '',
    captchaText: '',

    // 邮箱验证相关
    emailCode: '',
    isAdmin: false,
    emailCodeCooldown: 0,
    emailCodeTimer: null,

    userDeptRole: {
      userId: '',
      name: '',
      username: '',
      password: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    },

    userDeptRoleItems: [],
    userDeptRoleSel: {},

    step: 1,

    message: '',

    rules: {
      username: [
        v => !!v || '必填项。',
        v => (!v || v.trim().length === 0 || /^[@.A-Za-z0-9_-]+$/ig.test(v)) || '请输入统一社会信用代码、电子邮箱或用户名'
      ]
    }
  }),

  // 路由进入前，组件就未完成渲染，不可以使用 this
  beforeRouteEnter(to, from, next) {
    next(
      vm => {
        vm.afterLogin = to.query.redirect || null;
        vm.userDeptRole = {
          userId: '',
          name: '',
          username: '',
          password: '',
          deptId: '',
          deptName: '',
          roleId: '',
          roleName: '',
          roleRoute: null
        };
        vm.userDeptRoleItems = [];
        vm.userDeptRoleSel = {};
        vm.emailCode = '';
        vm.isAdmin = false;

        vm.step = 1;
        vm.message = '';
      });
  },

  // 路由改变前，组件就已经渲染完成，可以使用 this
  beforeRouteUpdate(to, from, next) {
    this.userDeptRole = {
      userId: '',
      name: '',
      username: '',
      password: '',
      deptId: '',
      deptName: '',
      roleId: '',
      roleName: '',
      roleRoute: null
    };
    this.userDeptRoleItems = [];
    this.userDeptRoleSel = {};
    this.emailCode = '';
    this.isAdmin = false;

    this.step = 1;
    this.message = '';

    next();
  },

  computed: {
    showMessage() {
      return this.message && this.message.length > 0;
    }
  },

  created() {
    if (this.$route.query.u) {
      this.onLoginX();
    }
    this.getCaptcha()
  },

  beforeDestroy() {
    if (this.emailCodeTimer) {
      clearInterval(this.emailCodeTimer);
    }
  },

  methods: {
    onLogin() {
      const vm = this;
      if (vm.loginLoading === true) return;

      vm.loginLoading = true;

      const username = this.userDeptRole.username;
      const password = this.userDeptRole.password;

      const token = xutil.token('GET', loginURI, 0, username, password, '', '');

      vm.message = '';
      // !!!Important, invalid last session
      this.$store.commit("logout");
      this.axios.get(loginURI, {
        headers: {
          'X-AUTH-TOKEN': token,
          'X-CAPTCHA-ID': this.captchaId,
          'X-CAPTCHA-TEXT': this.captchaText
        }
      })
        .then(
          rsp => {
            if (!Array.isArray(rsp.data)) {
              vm.message = rsp.data.message;
              vm.loginLoading = false;
              this.getCaptcha()
              return;
            }

            vm.userDeptRoleItems = rsp.data.map(
              udr => {
                delete udr.password;
                return udr;
              }
            );

            // 检查是否为admin用户
            vm.isAdmin = vm.userDeptRole.username.toLowerCase() === 'system';

            if (vm.isAdmin) {
              // admin用户需要邮箱验证
              vm.sendEmailCode();
              vm.step = 2;
            } else {
              // 普通用户直接进入角色选择
              vm.userDeptRoleSel = vm.userDeptRoleItems[0];
              Object.assign(vm.userDeptRole, vm.userDeptRoleSel);

              // 该用户只有一个部门和角色
              if (vm.userDeptRoleItems.length === 1) {
                this.doLogin();
              } else {
                vm.step = 3;
              }
            }
            vm.loginLoading = false;
          }
        )
        .catch(ex => {
          vm.loginLoading = false;
          this.getCaptcha()
        });
    },

    // 发送邮箱验证码
    sendEmailCode() {
      const vm = this;
      vm.axios.post('/api/login/send-email-code', {
        username: vm.userDeptRole.username
      })
        .then(rsp => {
          if (rsp.data && rsp.data.success) {
            vm.message = '验证码已发送到您的邮箱，请查收';
            vm.startEmailCodeCooldown();
          } else {
            vm.message = rsp.data ? rsp.data.message : '发送验证码失败';
          }
        })
        .catch(error => {
          vm.message = '发送验证码失败，请重试';
        });
    },

    // 验证邮箱验证码
    verifyEmailCode() {
      const vm = this;

      // 前端验证
      if (!vm.emailCode) {
        vm.message = '请输入邮箱验证码';
        return;
      }

      if (vm.emailCode.length !== 6) {
        vm.message = '验证码应为6位数字';
        return;
      }

      vm.loginLoading = true;

      vm.axios.post('/api/login/verify-email-code', {
        username: vm.userDeptRole.username,
        code: vm.emailCode
      })
        .then(rsp => {
          // 检查响应数据格式
          if (rsp.data && (rsp.data.success === true || rsp.data.success === "true")) {
            // 验证成功，进入角色选择
            vm.userDeptRoleSel = vm.userDeptRoleItems[0];
            Object.assign(vm.userDeptRole, vm.userDeptRoleSel);
            vm.step = 3;
            vm.message = '';
          } else {
            // 验证失败，显示错误信息并停留在当前步骤
            vm.message = rsp.data ? rsp.data.message : '验证码验证失败';
            // 可以清空验证码输入框，方便用户重新输入
            vm.emailCode = '';
          }
        })
        .catch(error => {
          vm.message = '验证失败，请重试';
          vm.emailCode = '';
        })
        .finally(() => {
          vm.loginLoading = false;
        });
    },

    // 开始验证码倒计时
    startEmailCodeCooldown() {
      const vm = this;
      vm.emailCodeCooldown = 60;
      if (vm.emailCodeTimer) {
        clearInterval(vm.emailCodeTimer);
      }
      vm.emailCodeTimer = setInterval(() => {
        vm.emailCodeCooldown--;
        if (vm.emailCodeCooldown <= 0) {
          clearInterval(vm.emailCodeTimer);
          vm.emailCodeTimer = null;
        }
      }, 1000);
    },

    onLoginX() {
      const vm = this;
      if (vm.loginLoading === true) return;

      vm.loginLoading = true;
      vm.message = '';
      // !!!Important, invalid last session
      this.$store.commit("logout");
      this.axios.post('/api/login/x', {"u": this.$route.query.u})
        .then(
          rsp => {
            if (rsp.data !== "") {
              let udr = rsp.data;
              console.log(udr);
              Object.assign(vm.userDeptRole, udr);

              // 检查是否为admin用户
              vm.isAdmin = vm.userDeptRole.username.toLowerCase() === 'system';

              if (vm.isAdmin) {
                vm.sendEmailCode();
                vm.step = 2;
              } else {
                vm.doLogin();
              }
            } else {
              vm.loginLoading = false;
              vm.step = 1;
            }
          }
        )
        .catch(_ => {
          vm.loginLoading = false;
        });
    },

    // 选择用户的部门和角色
    onDeptRoleChange(v) {
      Object.assign(this.userDeptRole, v);
    },

    doLogin() {
      const vm = this;
      vm.loginLoading = true;

      this.$store.commit("login", Object.assign({}, this.userDeptRole, {deptRoles: this.userDeptRoleItems}));

      const path = this.userDeptRole.roleRoute || this.afterLogin;
      this.$router.push(
        {path: path},
        () => vm.loginLoading = false, // onComplete
        () => vm.loginLoading = false, // onAbort
      );
    },

    getCaptcha() {
      this.axios.get(`${loginURI}/captcha`).then(rsp => {
        this.captchaId = rsp.data['captchaId']
        this.captchaUrl = rsp.data['captchaUrl']
      })
    }
  }
}
</script>
<style scoped>
div.stepper__content {
  padding: 0;
}

.email-code-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue